import { cn } from "@/lib/utils";
import React from "react";

export function SafeArea({ className, children }: {className?: string; children: React.ReactNode}) {
  return (
    <div className={cn("pt-safe h-[100dvh] flex flex-col overflow-hidden", className)}>
      {children}
    </div>
  );
}
